import { Suspense, useEffect } from 'react';

import { Outlet, useNavigate } from 'react-router-dom';

import ErrorBoundary from '../components/ErrorBoundary/ErrorBoundary';
import { Loader } from '../components/Loader/Loader';
import AppPortal from '../components/portals/AppPortal';
import { useHideLoader } from '../hooks/useHideLoader';
import { LocaleProvider } from '../providers';
import { navigationService } from '../services/navigation';
import { StoreProvider } from '../stores/StoreProvider';

export default function Layout() {
  useHideLoader();
  const navigate = useNavigate();

  useEffect(() => {
    navigationService.setNavigate(navigate);
  }, [navigate]);

  return (
    <StoreProvider>
      <LocaleProvider>
        <Suspense fallback={<Loader fullScreen />}>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </Suspense>
        <AppPortal />
      </LocaleProvider>
    </StoreProvider>
  );
}
